<template>
    <!--直播地址-->
    <Modal
            :value="value"
            @input="$emit('input', $event)"
            :title="$t('liveRoomManagement.liveRoomList.Button.liveUrlDialog.title')"
    >
        <div v-if="hasPermission('liveRoomMultiCDN')" v-show="enableCDN==0" style="margin-bottom:10px">
            <span style="font-weight: bold;">多线路(多CDN)：</span>
            <RadioGroup :value="multiCDN" @on-change="multiCDNChanged">
                <Radio :label="0"><span>关闭</span></Radio>
                <Radio :label="1"><span>开启</span></Radio>
            </RadioGroup>
        </div>
        <div>
            <span>{{ $t('liveRoomManagement.liveRoomList.Button.liveUrlDialog.hls') }}</span>
            <Input v-model="liveUrlInfo.hls" readonly style="width: 340px" />
            <Button type="primary" ref="hlsUrl" :data-clipboard-text="liveUrlInfo.hls">{{ $t('Button.copy.common') }}</Button>
            <span>{{ $t('liveRoomManagement.liveRoomList.Button.liveUrlDialog.rtmp') }}</span>
            <Input v-model="liveUrlInfo.rtmp" readonly style="width: 330px;margin: 10px 0" />
            <Button type="primary" ref="rtmpUrl" :data-clipboard-text="liveUrlInfo.rtmp">{{ $t('Button.copy.common') }}</Button>
        </div>
        <div v-if="hasPermission('liveRoomMultiCDN')" v-show="multiCDN==1 && enableCDN==0">
            <!-- <div style="margin-bottom: 5px;font-weight: bold;">线路2：</div> -->
            <Button size="small" @click="collapseBackupLive" style="margin-bottom: 5px">{{ showBackupLive?"隐藏线路2":"显示线路2" }}</Button>
            <span v-show="liveUrlInfo.optionalStream == true" class="streamming">推流中</span>
            <div v-show="showBackupLive == true">
                <span>{{ $t('liveRoomManagement.liveRoomList.Button.liveUrlDialog.hls') }}</span>
                <Input v-model="liveUrlInfo.optionalHLS" readonly style="width: 340px" />
                <Button type="primary" ref="optionalHlsUrl" :data-clipboard-text="liveUrlInfo.optionalHLS">{{ $t('Button.copy.common') }}</Button>
                <span>{{ $t('liveRoomManagement.liveRoomList.Button.liveUrlDialog.rtmp') }}</span>
                <Input v-model="liveUrlInfo.optionalRTMP" readonly style="width: 330px;margin: 10px 0" />
                <Button type="primary" ref="optionalRtmpUrl" :data-clipboard-text="liveUrlInfo.optionalRTMP">{{ $t('Button.copy.common') }}</Button>
            </div>
        </div>
        <div slot="footer"></div>
    </Modal>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import api from "@/api/Api";
import extend from "extend";
import apimodel from "@/model/ApiModel";
import Clipboard from "clipboard";
import QRCode from "qrcode";
import config from "@/config";

export default {
    props: ["roomId", "value"],
    data() {
        return {
            clipboards: [],
            liveUrlInfo: {
                hlsUrl: "",
                rtmpUrl: "",
                optionalRTMP: "",
                optinoalHLS: "",
                optionalStream: false
            },
            multiCDN: 0,
            enableCDN: 0,
            showBackupLive: false
        };
    },
    watch: {
        value(value) {
            if (value) {
                this.loadLiveUrl(this.roomId);
            }
        }
    },
    methods: {
        //获取直播地址
        async loadLiveUrl(id) {
            try {
                let ret = await api.call("liveRoom/showLiveUrl", {
                    roomId: id
                });
                this.liveUrlInfo = ret.data.playAddress;
                this.multiCDN = ret.data.playAddress.multiCDN;
                this.enableCDN = ret.data.enableCDN;
            } catch (e) {
                console.log(e);
                this.$Notice.error({ title: this.$t('Message.operation.error'), desc: e.resultMsg });
            }
        },
        //复制
        initCopy() {
            let refs = null;
            if(this.hasPermission('liveRoomMultiCDN')) {
                refs = [
                    this.$refs.hlsUrl.$el,
                    this.$refs.rtmpUrl.$el,
                    this.$refs.optionalHlsUrl.$el,
                    this.$refs.optionalRtmpUrl.$el
                ];
            } else {
                refs = [
                    this.$refs.hlsUrl.$el,
                    this.$refs.rtmpUrl.$el
                ];
            }
            let clipboards = refs.map(btn => {
                let clipboard = new Clipboard(btn);
                clipboard.on("success", e => {
                    this.$Message.success(this.$t('Message.copy.success'));
                });
                clipboard.on("error", e => {
                    // 不支持复制
                    this.$Message.success(this.$t('Message.copy.nonsupport'));
                });
                return clipboard;
            });
            this.clipboards = clipboards;
        },
        async multiCDNChanged(multiCDN) {
            console.log("multiCDN chagned: "+multiCDN);
            this.multiCDN = multiCDN;
            let inf = (multiCDN == 0?"liveRoom/disableMultiCDN":"liveRoom/enableMultiCDN");
            try {
                let ret = await api.call(inf, {}, {
                    roomId: this.roomId
                });
                this.loadLiveUrl(this.roomId);
            } catch (e) {
                console.log(e);
                this.$Message.warning(e.resultMsg);
                this.multiCDN = multiCDN==0?1:0;
            }
        },
        collapseBackupLive() {
            this.showBackupLive = !this.showBackupLive;
        }
    },
    mounted() {
        this.initCopy();
    },
    beforeDestroy() {
        this.clipboards.forEach(c => c.destroy());
    }
};
</script>
<style lang="less" scoped>
.streamming {
    margin-left: 5px;
    padding: 2px;
    color: white;
    background-color: #FF6666;
    border-radius: 5px;
    font-size: 12px;
    text-align: center;
}
</style>